<template>
  <article class="article" :id="'pointsystem-' + article.id">
    <header class="article__header">
      <div class="article__header-container">
        <h1 class="article__headline">
          {{ article.title }}
        </h1>
      </div>
      <div class="article__spins">
        <label
          v-if="article.genre"
          class="article__genre">{{ article.genre }}
        </label>
        <label>SPINS</label>
        <i class="bandwagon-logo bandwagon-logo--arc" />
        <label class="article__spins-number">
          {{ article.spins }}
        </label>
      </div>
    </header>

    <div class="flag-start"></div>

    
    <div class="progress-bar"  v-if="isUserLoggedIn">
      <div class="progress"></div>
      <div class="content-bar" ref="point">
        <div class="left-part">
          <div class="left-content read-time active-left"></div>
          <div class="left-time">
            <span class="minutes">00</span>&nbsp;:&nbsp;<span class="seconds">00</span>&nbsp;LEFT
          </div>
        </div>
        <div class="middle-part">
          <div class="content-desktop">Complete reading the article to receive&nbsp;<span class="text-point"></span></div>
          <div class="content-mobile">
            <div class="mobile-time">
              <span class="minutes">00</span>&nbsp;:&nbsp;<span class="seconds">00</span>&nbsp;left
            </div>
            &nbsp;and Complete for&nbsp;<span class="text-point"></span>
          </div>
        </div>
        <div class="right-part"></div>
      </div>
    </div>
    <div class="progress-bar" v-else>
      <div class="progress"></div>
      <div class="content-bar" id="point">
        <div class="left-part"></div>
        <div class="middle-part">
          <div class="content-middle active-middle">ESTIMATED&nbsp;<span class="read-time"></span></div>
        </div>
        <div class="right-part"></div>
      </div>
    </div>

    <div class="congratulation" :id="'congratulation-' + article.id" v-if="isUserLoggedIn">
      <dotlottie-player src="https://lottie.host/86659371-294f-424f-ac3b-a40d4554cb7b/RcgA58hd4b.lottie" background="transparent" speed="1.5" style="width: 100%;height: 100%;position: absolute;" loop autoplay></dotlottie-player>
    </div>

    <section class="article__cover-image-container">
      <img
        :src="article.coverImage"
        class="article__cover-image"
        :alt="article.title"
      >
    </section>

    <section
      class="article__body"
      onmousedown="return false;"
      onselectstart="return false;"
      oncontextmenu="return false;"
    >
      <aside class="article__meta-container">
        <div class="article__meta">
          <div class="article__byline" v-if="!article.hasBrandedContentCategory">
            Words by {{ article.author }}
          </div>
          <div class="article__date">
            {{ formattedPublishedAt }}
          </div>

          <ul
            v-if="article.categories.length > 0"
            class="article__category-list"
          >
            <li
              v-for="category in article.categories"
              :key="category.id"
              class="article__category-list-item"
            >
              {{ category.name }}
            </li>
          </ul>

          <div class="language-ctn" v-if="article.languageVersions.length > 0 ">
            <h4>Read in:</h4>
            <a
              v-for="version in article.languageVersions"
              :key="version.id"
              :href="`/articles/${article.slug}/${version.language}`"
              v-html="version.language"
              class="language-btn"
            />
          </div>

          <div
            v-if="article.audioActive && article.audioUrl"
          >
            <h4 class="audio-heading">Listen here:</h4>
            <div class="audio-player-container">
              <div class="audio-player-wrap">
                <button class="play-btn"><i class="fa fa-play"></i></button>
                <input
                  type="range"
                  class="seek-slider"
                  max="100"
                  value="0"
                >
                <span class="total-time">
                  <div
                    class="spinner-border"
                    role="status"
                  >
                    <span class="sr-only" />
                  </div>
                </span>
                <div class="volume-ctn">
                  <button class="mute-btn"><i class="fa fa-volume-up"></i></button>
                  <input
                    type="range"
                    class="volume-slider"
                    max="100"
                    value="100"
                  >
                </div>
                <audio
                  controls="controls"
                  controlsList="nodownload"
                  preload="metadata"
                  style="display: none"
                  class="audio-src"
                >
                  <source
                    :src="article.audioUrl"
                    type="audio/mpeg"
                  >
                </audio>
              </div>
              <div class="audio-control-mobile">
                <button class="rewind-btn">
                  <img src="/assets/rewind.svg" >
                </button>
                <button class="play-btn-mobile"><i class="fa fa-play"></i></button>
                <button class="forward-btn">
                  <img src="/assets/forward.svg" >
                </button>
              </div>
            </div>
          </div>
          <div class="article__sidebar-ad">
            <a :href="sidebarAd.url" :title="sidebarAd.message" target="_blank" v-if="sidebarAd">
              <img :src="sidebarAd.imageUrl" :alt="sidebarAd.message"/>
            </a>
            <GoogleAdvertComponent v-else />
          </div>
        </div>
      </aside>

      <aside class="article__right-ad-container">
        <div class="article__right-ad">
        </div>
      </aside>
      <section class="article__content" :id="'zoom-images-' + article.id">
        <div v-html="article.content"></div>
        <ReactionButton
          :key="article.id"
          :article="article"
        />
        <div class="flag-end"></div>
      </section>
      <div class="container">
        <hr class="firework-separate">
      </div>
    </section>

    <div class="newsletter__form--large">
      <NewsletterForm
        :country-newsletter-id="countryNewsletterId"
        :locale="locale"
      />
    </div>

    <div
      class="article-firework-embedded container"
    >
      <div class="article-firework-embedded-wrapper">
        <h2>Stories</h2>
        <fw-embed-feed
          channel="bandwagon"
          playlist="o88O1o"
          mode="grid"
          open_in="default"
          max_videos="8"
          paginate_by="4"
          placement="middle"
          player_placement="bottom-right"
          title=""
          branding="false"
        ></fw-embed-feed>
      </div>
    </div>
  </article>
</template>

<script>
import GoogleAdvertComponent from "../advert/GoogleAdvertComponent.vue";
import NewsletterForm from "../shared/NewsletterForm.vue";
import ReactionButton from "../shared/ReactionButton.vue"
import Viewer from 'viewerjs';

export default {
  components: {
    GoogleAdvertComponent,
    NewsletterForm,
    ReactionButton,
  },
  props: {
    article: {
      default: () => {},
      type: Object,
    },
    sidebarAd: {
      default: () => {},
      type: Object,
    },
    countryNewsletterId: {
      type: String,
      default: 'c04c8e2b7e',
    },
    locale: {
      type: String,
      default: 'en',
    },
  },
  computed: {
    formattedPublishedAt() {
      if (this.article.publishedAt === undefined) return "";

      return new Date(this.article.publishedAt).toLocaleString("en-SG", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
  data() {
    return {
      isUserLoggedIn: false,
      roundedReadTime: 0,
      windowHeight: window.innerHeight,
      hasTimeEnded: false,
      hasCompleted: false,
      counting: false,
      addPoint: false,
      isScrollEventActive: true,
      isLeftActive: true,
      pointTest: '+120 BWP',
      secondsRemaining: 0,
      articleRead: false,
      
    };
  },
  mounted() {
    const articleId = `#pointsystem-${this.article.id}`;
    const progressBar = document.querySelector(`${articleId} .progress-bar`);
    const progress = document.querySelector(`${articleId} .progress`);
    const readTime = document.querySelector(`${articleId} .read-time`);
    const paragraphs = document.querySelectorAll(`${articleId} .article__content p`);
    const pointArticle = document.querySelector(`${articleId} .content-bar`);
    const pointStart = document.querySelector(`${articleId} .flag-start`);
    const pointEnd = document.querySelector(`${articleId} .flag-end`);
    const textPointElements = document.querySelectorAll(`${articleId} .text-point`);
    const leftContent = document.querySelector(`${articleId} .left-content`) || null;
    const leftTime = document.querySelector(`${articleId} .left-time`) || null;
    
    this.handleReadTimeArticle(paragraphs, readTime);
    this.$nextTick(() => {
      window.addEventListener('scroll',() => this.handleScroll(pointStart, pointEnd, progress, progressBar, pointArticle, leftContent, leftTime));
    });
    if (this.isUserLoggedIn) {
      this.updateTextPoints(textPointElements);
    }

    this.$nextTick(() => {
      this.setupZoomOnImages();
    });
  },
  created() {
    this.isUserLoggedIn = document.getElementById('isUserLoggedIn').value  === "true";
    if (this.isUserLoggedIn) {
      this.fetchUserRead();
    }
  },
  methods: {
    setupZoomOnImages() {
      const articleId = 'zoom-images-' + this.article.id;
      new Viewer(document.getElementById(articleId), {
        toolbar: {
          zoomIn: 2,
          zoomOut: 2,
          oneToOne: 2,
          reset: 2,
          prev: 0,
          play: 0,
          next: 0,
          rotateLeft: 2,
          rotateRight: 2,
          flipHorizontal: 2,
          flipVertical: 2,
        },
      });
    },

    // Point System in Vue
    fetchUserRead() {
      fetch(`/articles/${this.article.slug}/get_read_articles?article_id=${this.article.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
        },
        
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch user actions');
        }
        return response.json();
      })
      .then(data => {
        this.articleRead = data.exists_for_id;
      })
      .catch(error => {
        console.error(error);
      });
    },
    handleReadTimeArticle(paragraphs, readTime) {
      let totalWords = 0;
      let roundedReadTime = 0;
      paragraphs.forEach(function(paragraph) {
        let words = paragraph.textContent.split(/\s+/).filter(function(word) {
            return word.length > 0;
        });
        totalWords += words.length;
      });

      let minReadTime = totalWords/200;
      roundedReadTime = minReadTime > Math.floor(minReadTime) + 0.5 ? Math.ceil(minReadTime) : Math.floor(minReadTime);
      this.roundedReadTime = roundedReadTime === 0 ? 1 : roundedReadTime;

      readTime.innerHTML = this.roundedReadTime + (this.roundedReadTime > 1 ? ' MINS READ' : ' MIN READ');
    },
    updateTextPoints(textPointElements) {
      textPointElements.forEach(element => {
        element.innerHTML = this.pointTest;
      });
    },
    updateCountdown() {
      const articleId = `#pointsystem-${this.article.id}`;
      const minutesElements = document.querySelectorAll(`${articleId} .minutes`);
      const secondsElements = document.querySelectorAll(`${articleId} .seconds`);

      const minutes = Math.floor(this.secondsRemaining / 60);
      const seconds = this.secondsRemaining % 60;

      minutesElements.forEach(element => {
        element.textContent = minutes < 10 ? '0' + minutes : minutes;
      });
      secondsElements.forEach(element => {
        element.textContent = seconds < 10 ? '0' + seconds : seconds;
      });
    },
    countdown() {
      if (!this.articleRead) {
        if (this.secondsRemaining === 0) {
          this.secondsRemaining = this.roundedReadTime * 60;
        }

        const articleId = `#pointsystem-${this.article.id}`;
        const leftTime = document.querySelector(`${articleId} .left-time`);
        const mobileTime = document.querySelector(`${articleId} .mobile-time`);

        if (this.secondsRemaining > 1) {
          this.updateCountdown();

          this.secondsRemaining -= 1;
          
          const self = this;
          setTimeout(function() {
            self.countdown();
          }, 1000);
        } else {
          leftTime.innerHTML = "TIMER ENDED";
          mobileTime.innerHTML = "Timer ended"
          this.hasTimeEnded = true;
          setTimeout( function () {
            leftTime.classList.remove("active-left");
          }, 5000); 
        }
      }
    },
    updateLeftText(leftContent, leftTime) {
      if (this.secondsRemaining > 0) {
        leftContent.classList.remove("active-left");
        leftTime.classList.add("active-left"); 
      }
    },
    handleScroll(pointStart, pointEnd, progress, progressBar, pointArticle, leftContent, leftTime) {
      const rectStart = pointStart.getBoundingClientRect();
      const rectEnd = pointEnd.getBoundingClientRect();

      if (this.isUserLoggedIn) {
        if (!this.isScrollEventActive) {
          return;
        }

        if (rectEnd.top <= this.windowHeight && this.addPoint) {
          this.showCongratulation();
          this.isScrollEventActive = false;
          return;
        } 

        if (rectStart.top <= 450) {
          if (this.isLeftActive) {
            this.countdown();
            setTimeout(this.updateLeftText(leftContent, leftTime), 5000);
            this.isLeftActive = false;
          }
          progressBar.classList.add("active-track");
          this.handleScrollArticle(rectStart, rectEnd, progress, progressBar, pointArticle);
        }

        if (rectStart.top > 450) {
          progressBar.classList.remove("active-track");
        }
      } else {
        if (rectStart.top <= 425) {
          progressBar.classList.add("active-track");
          this.handleScrollArticle(rectStart, rectEnd, progress);
        }
    
        if (rectStart.top > 425) {
          progressBar.classList.remove("active-track");
        }
      }
      
    },
    handleScrollArticle(rectStart, rectEnd, progress, progressBar = null, pointArticle = null) {
      const articleContentHeight = rectEnd.top - rectStart.top;
      let scrollHeight = this.windowHeight - (rectStart.top + 500); 
     
      if ( scrollHeight >= articleContentHeight) {
        scrollHeight = articleContentHeight
      }

      let scrollPercentage = (scrollHeight/articleContentHeight) * 100;

      progress.style.width = scrollPercentage + '%';
      
      if (this.isUserLoggedIn) {
        if (!this.articleRead) {
          if ( scrollHeight >= articleContentHeight) {
            scrollHeight = articleContentHeight
          }

          let scrollPercentage = (scrollHeight/articleContentHeight) * 100;

          progress.style.width = scrollPercentage + '%';
        
          this.hasCompleted = (scrollPercentage == 100)

          if (this.hasTimeEnded && this.hasCompleted && !this.addPoint) {
            this.addPoint = true;
            this.sendReadRequest(pointArticle, progressBar);
          }
        } else {
          progress.style.width = '100%';
          pointArticle.innerHTML = "Congratulations, you have received rewards from this article";
        }
      }
      
    },
    showCongratulation() {
      const articleId = `#pointsystem-${this.article.id}`;
      const eleCongratulation = document.querySelector(`${articleId} .congratulation`);
      eleCongratulation.classList.add('active-congratulation');

      setTimeout(function() {
        eleCongratulation.classList.remove('active-congratulation');
      }, 3000)
    },
    sendReadRequest(pointArticle, progressBar) {
      let currentURL = window.location.pathname;

      fetch(currentURL + '/read', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
        },
      })
      .then(response => {
        if (response.ok) {
          this.effectAddPoint(pointArticle, progressBar);
        }
        return response.json();
      })
      .then(data => {
        if (data.message) {
          pointArticle.innerHTML = 'Congratulations on receiving ' + data.message;
          pointArticle.style.color = "white";
        }
      })
      .catch(error => {
        console.error('Error sending read request:', error);
      });
    },
    effectAddPoint(pointArticle, progressBar) {
      progressBar.classList.add('active-add-point');
      pointArticle.classList.add('visible-ele');
      setTimeout(function() {
        progressBar.classList.remove('active-add-point');
        pointArticle.classList.remove('visible-ele');
      }, 3500);
    }
  },
};
</script>
